"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("../_internal/utils");
var isUndefined_1 = tslib_1.__importDefault(require("../isUndefined"));
var max_1 = tslib_1.__importDefault(require("../max"));
var nth_1 = tslib_1.__importDefault(require("../nth"));
var pipe_1 = tslib_1.__importDefault(require("../pipe"));
var size_1 = tslib_1.__importDefault(require("../size"));
var toArray_1 = tslib_1.__importDefault(require("../toArray"));
var filter_1 = tslib_1.__importDefault(require("./filter"));
var map_1 = tslib_1.__importDefault(require("./map"));
var toAsync_1 = tslib_1.__importDefault(require("./toAsync"));
function sync(iterable) {
    var maxLen, index;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                maxLen = (0, pipe_1.default)(iterable, (0, map_1.default)(size_1.default), max_1.default);
                index = 0;
                _a.label = 1;
            case 1:
                if (!(index < maxLen)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, pipe_1.default)(iterable, (0, map_1.default)((0, nth_1.default)(index)), (0, filter_1.default)(function (value) { return !(0, isUndefined_1.default)(value); }), toArray_1.default)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                index++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
function async(iterable) {
    var _a;
    var iterators = (0, toArray_1.default)((0, map_1.default)(utils_1.toIterator, iterable));
    return _a = {},
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a.next = function (_concurrent) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var headIterators, done;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, pipe_1.default)((0, toAsync_1.default)(iterators), (0, map_1.default)(function (iterator) { return iterator.next(_concurrent); }), toArray_1.default)];
                        case 1:
                            headIterators = _a.sent();
                            done = headIterators.every(function (_a) {
                                var done = _a.done;
                                return done;
                            });
                            if (done)
                                return [2 /*return*/, { done: true, value: undefined }];
                            return [2 /*return*/, {
                                    done: false,
                                    value: (0, pipe_1.default)(headIterators, (0, map_1.default)(function (_a) {
                                        var value = _a.value;
                                        return value;
                                    }), (0, filter_1.default)(function (value) { return !(0, isUndefined_1.default)(value); }), toArray_1.default),
                                }];
                    }
                });
            });
        },
        _a;
}
function transpose() {
    var iterables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        iterables[_i] = arguments[_i];
    }
    if ((0, size_1.default)(iterables) < 2)
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return transpose.apply(void 0, tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(iterables), false), tslib_1.__read(args), false));
        };
    if (iterables.some(function (value) { return !(0, utils_1.isIterable)(value) && !(0, utils_1.isAsyncIterable)(value); })) {
        throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
    }
    var hasAsyncIterable = iterables.some(function (iterable) {
        return (0, utils_1.isAsyncIterable)(iterable);
    });
    if (hasAsyncIterable) {
        return async(iterables);
    }
    return sync(iterables);
}
exports.default = transpose;
//# sourceMappingURL=transpose.js.map